module.exports = __webpack_public_path__ + "img/1_011.160708c8.jpg";